// © Microsoft Corporation. All rights reserved.
// IF YOU UPDATE THIS FILE PLEASE UPDATE THE ONE IN @msnews/core
// DUE TO TREE SHAKING ISSUES WHEN IN DEBUG WE CAN'T USE COMMON CODE
// WITHOUT CAUSING ISSUES IN WebWorker
export var UrlUtility;
(function (UrlUtility) {
    /**
     * Parse specific parameters from the given query string, allowing for multiple item=key:value.
     * This function ONLY parses qsp item=[key]:[value]
     * Note: Use first given rule for duplicate key!
     * @param {string} queryString - the query string to parse for parameters
     * @returns {KeyValueArray<string, string>} - the parsed query key/value collection
     */
    function getParamsWithItems(queryString) {
        const params = [];
        const inputKey = "item";
        if (queryString) {
            // Remove the leading ? if it is present
            if (queryString.startsWith("?")) {
                queryString = queryString.substring(1);
            }
            // split on the hashes.
            queryString = queryString.split("#")[0];
            const queryArray = queryString.split("&");
            for (let ndx = 0; ndx < queryArray.length; ndx++) {
                const parts = queryArray[ndx].split("=");
                let queryKey = parts[0];
                let queryValue = parts[1];
                // If the query key is inputKey (default: "item"), and the query values is key:value, then convert the
                // value into the actual key/value
                if (queryKey.toLowerCase() === inputKey) {
                    const queryItems = queryValue.split(":");
                    // Ignore value not in "key:value" format
                    if (queryItems.length === 2) {
                        queryKey = queryItems[0];
                        queryValue = queryItems[1];
                        // Don't allow for duplicate query string parameter keys. Use first given rule for duplicate key!
                        const newParam = { key: queryKey, value: queryValue };
                        const existingParam = params.findIndex((entry) => entry.key === newParam.key);
                        if (existingParam === -1) {
                            params.push(newParam);
                        }
                    }
                }
            }
        }
        return params;
    }
    UrlUtility.getParamsWithItems = getParamsWithItems;
})(UrlUtility || (UrlUtility = {}));
//# sourceMappingURL=UrlUtility.js.map